import classnames from 'classnames/bind';
import styles from './infoListBanner.module.scss';
const cx = classnames.bind(styles);

const InfoListBanner = () => {
  return (
    <div className={cx('bannerArea')}>
      <span className={cx('hidden')}>취업에 필요한 모든 콘텐츠, 잡다가 다 잡았다!</span>
    </div>
  );
};

export default InfoListBanner;
